import { tap } from 'rxjs/operators';
import { WebApi } from 'app/core/web-api.service';
var UserRoles = {
    AccountAdmin: 'account_admin',
    AccountUser: 'account_user',
    NewUser: 'new_user',
    InvitedUser: 'invited_user',
    DeactivatedUser: 'deactivated_user',
    ServiceAdmin: 'service_admin'
};
var UserService = /** @class */ (function () {
    function UserService(_webApi) {
        this._webApi = _webApi;
    }
    Object.defineProperty(UserService.prototype, "userName", {
        get: function () {
            if (this.user) {
                return ((this.user.firstName || '') + " " + (this.user.lastName || '')).trim() || this.user.email;
            }
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.init = function () {
        var _this = this;
        return this._webApi.getOnce('/v1/user').pipe(tap(function (user) { _this.user = user; }));
    };
    UserService.prototype.isAdmin = function () {
        return this._hasRole(UserRoles.AccountAdmin) || this._hasRole(UserRoles.ServiceAdmin);
    };
    UserService.prototype.isUserServiceAdmin = function () {
        return this._hasRole(UserRoles.ServiceAdmin);
    };
    UserService.prototype._hasRole = function (role) {
        return this.user.roles.indexOf(role) >= 0;
    };
    return UserService;
}());
export { UserService };
